// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ex-s","col":"styles_col__1xKVI"};